export default {
  "content": "<path d=\"M13 12h2.5v2H12a1 1 0 01-1-1V9h2v3z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 4c2.247 0 4.3.827 5.877 2.188l1.896-1.895 1.415 1.414-1.95 1.947A9 9 0 1112 4zm0 2a7 7 0 100 14 7 7 0 000-14z\" fill=\"#7B61FF\"/><path d=\"M15 3H9V1h6v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};